document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('a[href*="#"]');

    anchors.forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            let hash = '';

            // Extract hash from different formats
            if (href.startsWith('#')) {
                hash = href;
            } else if (href.includes('#')) {
                const url = new URL(href, window.location.origin);
                // Check if it's the same page (same origin and pathname)
                if (url.origin === window.location.origin &&
                    (url.pathname === window.location.pathname || url.pathname === '/')) {
                    hash = url.hash;
                }
            }

            if (!hash || hash === '#') return;

            const targetElement = document.querySelector(hash);

            if (targetElement) {
                e.preventDefault();

                const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 80;

                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });

                if (history.pushState) {
                    history.pushState(null, null, hash);
                }
            }
        });
    });
});
